import React, {Component} from 'react';
import {connect} from 'react-redux';
import {NavLink, withRouter} from 'react-router-dom';

import IntlMessages from 'util/IntlMessages';
import CustomScrollbars from 'util/CustomScrollbars';


class SidenavContent extends Component {
    componentDidMount() {
        const {history} = this.props;
        const that = this;
        const pathname = `#${history.location.pathname}`;// get current path

        const subMenuLi = document.querySelectorAll('.sub-menu > li');
        for (let i = 0; i < subMenuLi.length; i++) {
            subMenuLi[i].onclick = function (event) {
                event.stopPropagation();
            }
        }

        const menuLi = document.getElementsByClassName('menu');
        for (let i = 0; i < menuLi.length; i++) {
            menuLi[i].onclick = function (event) {
                for (let j = 0; j < menuLi.length; j++) {
                    const parentLi = that.closest(this, 'li');
                    if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
                        menuLi[j].classList.remove('open')
                    }
                }
                this.classList.toggle('open');
                event.stopPropagation();
            }
        }

        const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
        try {
            const activeNav = this.closest(activeLi, 'ul'); // select closest ul
            if (activeNav.classList.contains('sub-menu')) {
                this.closest(activeNav, 'li').classList.add('open');
            } else {
                this.closest(activeLi, 'li').classList.add('open');
            }
        } catch (error) {

        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {history} = this.props;
        const that = this;
        const pathname = `#${history.location.pathname}`;// get current path

        const subMenuLi = document.querySelectorAll('.sub-menu > li');
        for (let i = 0; i < subMenuLi.length; i++) {
            subMenuLi[i].onclick = function (event) {
                event.stopPropagation();
            }
        }

        const menuLi = document.getElementsByClassName('menu');
        for (let i = 0; i < menuLi.length; i++) {
            menuLi[i].onclick = function (event) {
                for (let j = 0; j < menuLi.length; j++) {
                    const parentLi = that.closest(this, 'li');
                    if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
                        menuLi[j].classList.remove('open')
                    }
                }
                this.classList.toggle('open');
                event.stopPropagation();
            }
        }

        const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
        try {
            const activeNav = this.closest(activeLi, 'ul'); // select closest ul
            if (activeNav.classList.contains('sub-menu')) {
                this.closest(activeNav, 'li').classList.add('open');
            } else {
                this.closest(activeLi, 'li').classList.add('open');
            }
        } catch (error) {

        }
    }

    closest(el, selector) {
        try {
            let matchesFn;
            // find vendor prefix
            ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
                if (typeof document.body[fn] == 'function') {
                    matchesFn = fn;
                    return true;
                }
                return false;
            });

            let parent;

            // traverse parents
            while (el) {
                parent = el.parentElement;
                if (parent && parent[matchesFn](selector)) {
                    return parent;
                }
                el = parent;
            }
        } catch (error) {

        }

        return null;
    }

    serviceIcon = (type) => {
        switch (type) {
            case 'vdsl':
            case 'gpon':
            case 'tal':
                return 'zmdi zmdi-router zmdi-hc-fw';
            case 'sdsl':
                return 'zmdi zmdi-code-setting zmdi-hc-fw';
            case 'pbx':
                return 'zmdi zmdi-phone zmdi-hc-fw';
            case 'iptv':
                return 'zmdi zmdi-tv-play zmdi-hc-fw';
            case 'colo':
                return 'zmdi zmdi-dns zmdi-hc-fw';
            case 'email':
                return 'zmdi zmdi-email zmdi-hc-fw';
            default:
                return 'zmdi zmdi-router zmdi-hc-fw';
        }
    } 

    servicePrefix = (type) => {
        switch (type) {
            case 'vdsl':
                return 'VDSL';
            case 'gpon':
                return 'FIBER';
            case 'tal':
                return 'DSL';
            case 'sdsl':
                return 'SDSL';
            case 'pbx':
                return 'PBX';
            case 'iptv':
                return 'IPTV Fernsehen';
            case 'colo':
                return 'COLO';
            case 'email':
                return 'E-Mail Adressen';
            default:
                return null;
        }
    } 

    render() {
        let highestMst = 0;
        if (this.props.invoices) {
            if (this.props.invoices.find(i => i.mst>0)) {
                highestMst = 1;
            }
            if (this.props.invoices.find(i => i.mst>1)) {
                highestMst = 2;
            }
            if (this.props.invoices.find(i => i.mst>2)) {
                highestMst = 3;
            }
        }
        return (
            <CustomScrollbars className="scrollbar">
                <ul className="nav-menu">

                    <li className="nav-header"><IntlMessages id="sidebar.myServices"/></li>
                    {
                        this.props.services && this.props.services.filter(e => !['email','iptv'].includes(e.type)).map((row) => 
                        <li className="menu no-arrow" key={row.id}>
                            <NavLink to={"/app/service/" + row.id}>
                                <i className={this.serviceIcon(row.type)}/>
                                <span className="nav-text">{this.servicePrefix(row.type)} {row.id} {row.alert && <i className="zmdi zmdi-alert-triangle zmdi-hc-fw" style={{marginLeft: '5px', color: "red"}}/>} </span>
                            </NavLink>
                        </li>
                    )}
                    {
                        this.props.services && this.props.services.filter((e) => e.type==='iptv').map((row) =>
                        <li className="menu no-arrow" key={row.id}>
                            <NavLink to={"/app/iptv/" + row.id}>
                                <i className={this.serviceIcon(row.type)}/>
                                <span className="nav-text">{this.servicePrefix(row.type)} {row.alert && <i className="zmdi zmdi-alert-triangle zmdi-hc-fw" style={{marginLeft: '5px', color: "red"}}/>} </span>
                            </NavLink>
                        </li>
                    )}
                    {
                        this.props.services && this.props.services.filter((e) => e.type==='email').map((row) =>
                        <li className="menu no-arrow" key="Email">
                            <NavLink to={"/app/email"}>
                                <i className={this.serviceIcon('email')}/>
                                <span className="nav-text">{this.servicePrefix('email')} {row.alert && <i className="zmdi zmdi-alert-triangle zmdi-hc-fw" style={{marginLeft: '5px', color: "red"}}/>} </span>
                            </NavLink>
                        </li>
                    )}
                    
                    <li className="nav-header"><IntlMessages id="sidebar.help"/></li>
                    <li className="menu no-arrow">
                        <NavLink to="/app/faq">
                            <i className="zmdi zmdi-pin-help zmdi-hc-fw"/>
                            <span className="nav-text"><IntlMessages id="pages.faq"/> </span>
                        </NavLink>
                    </li>
                    <li className="menu no-arrow">
                        <NavLink to="/app/support">
                            <i className="zmdi zmdi-comments zmdi-hc-fw"/>
                            <span className="nav-text"><IntlMessages id="pages.support"/> </span>
                        </NavLink>
                    </li>

                    <li className="nav-header"><IntlMessages id="sidebar.myData"/></li>
                    <li className="menu no-arrow">
                        <NavLink to="/app/invoices">
                            <i className="zmdi zmdi-receipt zmdi-hc-fw"/>
                            <span className="nav-text"><IntlMessages id="pages.invoices"/> {highestMst>2?<i className="zmdi zmdi-alert-triangle zmdi-hc-fw" style={{marginLeft: '5px', color: "red"}}/>:(highestMst>1?<i className="zmdi zmdi-alert-triangle zmdi-hc-fw" style={{marginLeft: '5px', color: "#C7B327"}}/>:null)}</span>
                        </NavLink>
                    </li>
                    <li className="menu no-arrow">
                        <NavLink to="/app/mydata">
                            <i className="zmdi zmdi-card zmdi-hc-fw"/>
                            <span className="nav-text"><IntlMessages id="pages.myData"/> </span>
                        </NavLink>
                    </li>
                </ul>
            </CustomScrollbars>
        );
    }
}

const mapStateToProps = function(state){
    return {
        services: state.services,
        invoices: state.invoices && state.invoices.openInvoices,
//        faq: state.faq
    }
};

export default withRouter(connect(mapStateToProps)(SidenavContent));
